export function moduleScriptUrl(html: string, baseUrl: string) {
  const scripts = html.matchAll(/<script\b[^>]*\bsrc=["']([^"']+)["'][^>]*>/gi);
  for (const match of scripts) {
    if (/\btype=["']module["']/i.test(match[0])) return new URL(match[1], baseUrl).href;
  }
  return null;
}

export function clientReleaseIsStale(html: string, currentModuleUrl: string, baseUrl: string) {
  const latestModuleUrl = moduleScriptUrl(html, baseUrl);
  return latestModuleUrl !== null && latestModuleUrl !== new URL(currentModuleUrl, baseUrl).href;
}
